import { Box, Tooltip } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import NirantaraIcon from "../assets/images/vajra.svg";
import { getConsultantIconUrl } from "../utils/consultantLogo";
import {
  miniSidebarElements,
  sidebarElements1,
  sidebarElementsFacility,
} from "../utils/constant";
import styles from "../styles/layout/brsrsidebar.module.css";
import SidebarItemsRenderer from "../utils/layoutFunctions";
// import { useBRSR } from "../context/BRSRContext";
import useBRSRStore from "../store/BRSRstore";
import { get } from "../utils/api";
import { useUser } from "../context/AuthContext";
import {
  filterMiniSidebarElements,
  getRoleBasedSidebar,
} from "../utils/sidebarFunctions";

const BRSRSidebar = () => {
  const { user } = useUser();
  const location = useLocation();
  const navigate = useNavigate();
  const sidebarRef = useRef(null);
  const { id } = useParams();
  const { brsrId } = useBRSRStore();
  const { selectedBRSR } = useBRSRStore();
  const [disable, setDisable] = useState(true);

  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    const sidebarEl = sidebarRef.current;
    if (!sidebarEl) return;

    const handleScroll = () => {
      localStorage.setItem("sidebarScrollTop", sidebarEl.scrollTop);
    };

    sidebarEl.addEventListener("scroll", handleScroll);

    return () => {
      sidebarEl.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const sidebarEl = sidebarRef.current;
    const savedScrollTop = localStorage.getItem("sidebarScrollTop");

    if (sidebarEl && savedScrollTop) {
      sidebarEl.scrollTop = parseInt(savedScrollTop, 10);
    }
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      console.log(id, "id");
      try {
        const response = await get(`/brsr/get/status?id=${id}`);
        if (response?.data?.brsrSubmitted === false) {
          console.log(response?.data?.brsrSubmitted, "response1");
          setDisable(true);
        } else {
          setDisable(false);
        }
        console.log(response?.data?.brsrSubmitted, "response1");
      } catch (err) {
        console.log(err);
      }
    };
    fetchData();
  }, [id]);

  const brsrSidebarElements = [
    { text: "Instructions", path: `/brsr/section-a` },
    { text: "Section A", path: "/brsr/section-a" },
    { text: "Section B", path: "/brsr/section-b" },
    { text: "Section C", path: "/brsr/section-c" },
    // { text: "Review And Submit", path: "/brsr/review" },
  ];

  const sectionCSidebarElements = [
    { text: "Instructions", path: "/brsr/section-c/instructions" },
    { text: "Principle 1", path: "/brsr/section-c/principle1" },
    { text: "Principle 2", path: "/brsr/section-c/principle2" },
    { text: "Principle 3", path: "/brsr/section-c/principle3" },
    { text: "Principle 4", path: "/brsr/section-c/principle4" },
    { text: "Principle 5", path: "/brsr/section-c/principle5" },
    { text: "Principle 6", path: "/brsr/section-c/principle6" },
    { text: "Principle 7", path: "/brsr/section-c/principle7" },
    { text: "Principle 8", path: "/brsr/section-c/principle8" },
    { text: "Principle 9", path: "/brsr/section-c/principle9" },
    { text: "Review And Submit", path: "/brsr/review", disable: disable },
  ];

  const sidebarElements = getRoleBasedSidebar({
    user,
    sidebarElements1,
    sidebarElementsFacility,
  });

  const filteredSidebar = sidebarElements.map((item) => {
    if (item.path === "/production-revenue") {
      return {
        ...item,
        heading: user?.companyAdmin ? "Production & Revenue" : "Production",
      };
    }
    if (item.heading === "Setup" && item.subData) {
      const newSubData = item.subData.filter(
        (sub) => sub.primary !== "Facility Master" || !user?.facility
      );
      return { ...item, subData: newSubData };
    }
    return item;
  });

  const miniSidebarFiltered = filterMiniSidebarElements({
    user,
    miniSidebarElements,
  });

  const renderMainSidebarItems = (elements) => {
    return elements.map((item, index) => (
      <div
        key={index}
        style={{
          fontFamily: "Inter",
          display: "flex",
          flexDirection: "column",
          marginTop: "0.25rem",
        }}
      >
        <div
          key={index}
          style={{
            display: "flex",
            justifyContent: "center",
            backgroundColor:
              item.primary === "ESG Reporting" ? "#1C486B" : "transparent",
          }}
        >
          <Tooltip
            title={item.title}
            arrow
            placement="bottom-start"
            PopperProps={{
              modifiers: [
                {
                  name: "offset",
                  options: {
                    offset: [0, 0],
                  },
                },
              ],
            }}
            componentsProps={{
              tooltip: {
                sx: {
                  color: "#fff",
                  fontSize: "12px",
                  borderRadius: "4px",
                  padding: "0.25rem 0.5rem",
                },
                arrow: {
                  color: "#fff",
                },
              },
            }}
          >
            <a
              href={item.path}
              key={item.primary}
              style={{
                textDecoration: "none",
                color: "green",
                padding: "0.4rem",
                borderRadius: "4px",
              }}
            >
              <Box
                component="img"
                src={item.icon}
                alt={"img"}
                sx={{
                  width: "24px",
                  height: "24px",
                  filter: location.pathname.startsWith(item.pathLink1)
                    ? "invert(1)"
                    : "invert(0)",
                }}
              />
            </a>
          </Tooltip>
        </div>
      </div>
    ));
  };

  const renderSecondarySidebarItems = (heading) => {
    return (
      <div ref={sidebarRef} className={styles.secondarySidebar}>
        {heading && <p className={styles.sidebarHeading}>{heading}</p>}
        <div className={styles.progressBarDiv}>
          {/* <progress
            id="file"
            value="10"
            max="100"
            className={styles.progressBar}
          />
          <p className={styles.progressbar_value}>10%</p> */}
        </div>
        <div className={styles.sidebarList}>
          {[
            ...brsrSidebarElements,
            ...(location.pathname.includes("/brsr/section-c")
              ? disable
                ? sectionCSidebarElements?.filter(
                    (item) => item.text !== "Review And Submit"
                  )
                : sectionCSidebarElements
              : disable
              ? [] // 👈 hide Review & Submit if disable is true
              : [{ text: "Review And Submit", path: "/brsr/review" }]),
          ].map((brsr, idx, array) => (
            <React.Fragment key={idx}>
              <div
                className={styles.sidebarItem}
                onClick={() => {
                  if (location.pathname !== brsr.path) {
                    navigate(
                      brsr.path === "/brsr/section-c"
                        ? `/brsr/section-c/instructions/${selectedBRSR}`
                        : `${brsr.path}/${selectedBRSR}`
                    );
                  }
                }}
              >
                <div
                  className={
                    location.pathname.includes(brsr.path)
                      ? styles.sidebarDotActive
                      : styles.sidebarDot
                  }
                ></div>
                <p className={styles.sidebarText}>{brsr.text}</p>
              </div>

              {idx !== array.length - 1 && (
                <div className={styles.sidebarConnector}></div>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    );
  };

  return (
    <Box className={styles.sidebarContainer}>
      <div
        className={styles.mainSidebar}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <Box className={styles.logoContainer}>
          <img
            src={getConsultantIconUrl() || NirantaraIcon}
            alt="Nirantara Logo"
            style={
              getConsultantIconUrl()
                ? { cursor: "pointer", height: "36px", width: "36px", objectFit: "contain" }
                : { cursor: "pointer", height: "44px", width: "auto", objectFit: "contain" }
            }
            onClick={() => navigate("/dashboard")}
          />
        </Box>
        <div className={styles.sidebarContent}>
          {renderMainSidebarItems(miniSidebarFiltered)}
        </div>
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "21.3vw",
            height: "100vh",
            backgroundColor: "#fff",
            zIndex: 10,
            overflowY: "auto",
            transform: isHovered ? "translateX(0)" : "translateX(-100%)",
            opacity: isHovered ? 1 : 0,
            transition: "opacity 0.4s ease, transform 0.4s ease",
            pointerEvents: isHovered ? "auto" : "none",
            willChange: "transform, opacity",
          }}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          {<SidebarItemsRenderer elements={filteredSidebar} />}
        </div>
      </div>
      {renderSecondarySidebarItems("BRSR Report")}
    </Box>
  );
};

export default BRSRSidebar;
